<template>
    <div class="layout-footer">
        <div class="footer-logo-container">
            <img id="footer-logo" :src="'layout/images/logo-' + colorScheme + '.png'" alt="GA Moosehead" />
            <span class="app-name">Moosehead</span>
        </div>
        <span class="copyright">&#169; Grassroots Analytics - 2024</span>
    </div>
</template>

<script>
export default {
    props: {
        colorScheme: String,
    },
};
</script>
